export default {
  'component.tagSelect.expand': 'გაფართოება',
  'component.tagSelect.collapse': 'შეკუმშვა',
  'component.tagSelect.all': 'ყველა',
};
